import $ from "jquery";

const leadershipObj = {
    variable:{
        url: window.location.href,
    },
    methods: {
        init: function () {
            $('.leader-profile__award_thumb, .leader-profile__image_thumb').on('click', function(){
                    var obj = leadershipObj.methods.dataLayerObj();
                    createDataLayer('BannerClick', obj);
                });
            $('.info-links__list_item').on('click', function(e){
                    var obj = leadershipObj.methods.dataLayerObj(e);
                    createDataLayer('SocialMediaShare', obj);
                });
        },
        dataLayerObj: function (e) {
            var obj = {
                'articleName' : leadershipObj.variable.url.includes('leadership-team') ? "Leader Detail" : "Awarded third year in a row",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.href.includes("linkedin") ? "linkedin" : "",
                'pageSection' : leadershipObj.variable.url.includes('leadership-team') ? "Leader Banner" : "Awards Banner",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? leadershipObj.variable.url.includes("blog") ? "Blogs" : leadershipObj.variable.url.substring(leadershipObj.variable.url.indexOf(".com/"), leadershipObj.variable.url.lastIndexOf('/')  === ".com") && !leadershipObj.variable.url.substring(leadershipObj.variable.url.indexOf(".com/"), leadershipObj.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",

            };
            return obj;
        },
    },
};

$(() => {
    if ($(".leader-profile").length) {
        leadershipObj.methods.init();
    }
});
